import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "./components/ui/sonner";
import { AppProvider, useApp } from "./context/AppCtx";
import { Sidebar } from "./components/shell/Sidebar";
import { Topbar } from "./components/shell/Topbar";
import RecordDrawer from "./components/RecordDrawer";
import { Restricted, Empty } from "./components/kit";
import { REGISTRY } from "./worlds/registry";
import { WORLDS } from "./lib/worlds";
import AdhocHub from "./worlds/AdhocHub";
import ReportsHub from "./worlds/ReportsHub";
import SettingsPage from "./worlds/SettingsPage";
import { ReportStudio } from "./worlds/studio";

function WorldPage() {
  const { world = "group", module = "overview" } = useParams();
  const { can } = useApp();
  if (!WORLDS[world]) return <Empty label="Unknown area." />;
  if (!can(world, module)) return <Restricted world={world} />;
  const C = REGISTRY[world]?.[module];
  return C ? <C /> : <Empty label="Module not found." />;
}

function Shell() {
  const loc = useLocation();
  const [mobile, setMobile] = useState(false);
  const world = loc.pathname.split("/")[1] || "group";
  return (
    <div className="flex min-h-screen" data-world={WORLDS[world] ? world : "group"}>
      <Sidebar />
      {mobile && <div className="fixed inset-0 z-[1500] flex lg:hidden" data-testid="mobile-sidebar"><Sidebar mobile onClose={() => setMobile(false)} /><div className="flex-1 bg-black/40" onClick={() => setMobile(false)} /></div>}
      <div className="flex-1 min-w-0 flex flex-col bg-[var(--surface)] transition-colors duration-500">
        <Topbar onMenu={() => setMobile(true)} />
        <AnimatePresence mode="wait">
          <motion.main key={loc.pathname.split("/").slice(0, 3).join("/")} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.22 }} className="flex-1 p-4 lg:p-7 max-w-[1680px] w-full mx-auto">
            <Routes location={loc}>
              <Route path="/" element={<WorldPage />} />
              <Route path="/adhoc" element={<AdhocHub />} />
              <Route path="/reports" element={<ReportsHub />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/studio" element={<ReportStudio />} />
              <Route path="/:world" element={<WorldPage />} />
              <Route path="/:world/:module" element={<WorldPage />} />
            </Routes>
          </motion.main>
        </AnimatePresence>
        <footer className="px-7 py-4 text-[11px] text-[#A8A29E] border-t border-[#EFECE4]">Afrikho Intelligence · Enterprise Experience Demonstrator by Nsync Dimensions · All data fictional & illustrative · Not a certified production system</footer>
      </div>
      <RecordDrawer />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter><Shell /></BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AppProvider>
  );
}
